// Review sources configuration for Petsmart Puppies
// This architecture supports both Google and Justdial review platforms

export const REVIEW_SOURCES = {
  google: {
    platform: 'Google',
    placeId: 'ChIJ0Z1234567890', // Placeholder - set actual Place ID when available
    profileUrl: 'https://maps.app.goo.gl/bQNaxyM5CxgCTNSe8',
    // Publicly visible data from Google Business Profile
    // These should be updated when backend API integration is implemented
    rating: 4.6,
    reviewCount: 199,
    lastUpdated: '2026-05-06',
    icon: 'google',
    color: '#4285F4'
  },
  justdial: {
    platform: 'Justdial',
    listingUrl: 'https://www.justdial.com/Noida/Petsmart-Puppies-Opp-Dr-Bheemrao-Ambedkar-Hospital-Noida-Sector-31/011PXX11-XX11-181015170307-A4B1_BZDET',
    // Publicly visible data from Justdial listing
    rating: 4.8,
    reviewCount: 500, // Displayed as "500+ ratings" to avoid staleness
    reviewCountDisplay: '500+',
    lastUpdated: '2026-05-06',
    icon: 'justdial',
    color: '#FFD700'
  }
};

// Business information - consistent across all platforms
export const BUSINESS_INFO = {
  name: 'Petsmart Puppies',
  address: {
    street: 'Shop No:- D1 Ground Floor',
    landmark: 'Near DR Bhimrao Ambedkar Multispeciality Hospital',
    area: 'Indergarhi',
    sector: 'Sector 31',
    city: 'Noida',
    state: 'Uttar Pradesh',
    country: 'India',
    pincode: '201303'
  },
  phone: '+91 7217648679',
  whatsapp: '917217648679',
  email: null, // Add when available
  website: 'https://petsmartpuppies.com/',
  openingHours: {
    days: 'Monday - Sunday',
    hours: 'Open until 10:00 PM'
  },
  socialMedia: {
    instagram: 'https://www.instagram.com/petshopnoida/',
    facebook: 'https://www.facebook.com/share/1C5p2xwiCX/',
    youtube: 'https://www.youtube.com/@petsmartpetshop'
  },
  geo: {
    latitude: 28.5744, // Approximate - verify with actual coordinates
    longitude: 77.3526
  }
};

// Format full address
export const getFullAddress = () => {
  const { address } = BUSINESS_INFO;
  return `${address.street}, ${address.landmark}, ${address.area}, ${address.sector}, ${address.city}, ${address.state} ${address.pincode}, ${address.country}`;
};

// Generate LocalBusiness schema
export const getLocalBusinessSchema = () => ({
  '@context': 'https://schema.org',
  '@type': 'PetStore',
  '@id': 'https://petsmartpuppies.com/#store',
  name: BUSINESS_INFO.name,
  image: 'https://petsmartpuppies.com/petsmart-logo.png',
  logo: 'https://petsmartpuppies.com/petsmart-logo.png',
  url: BUSINESS_INFO.website,
  telephone: BUSINESS_INFO.phone.replace(/\s+/g, ''),
  hasMap: REVIEW_SOURCES.google.profileUrl,
  address: {
    '@type': 'PostalAddress',
    streetAddress: `${BUSINESS_INFO.address.street}, ${BUSINESS_INFO.address.landmark}, ${BUSINESS_INFO.address.area}, ${BUSINESS_INFO.address.sector}`,
    addressLocality: BUSINESS_INFO.address.city,
    addressRegion: BUSINESS_INFO.address.state,
    postalCode: BUSINESS_INFO.address.pincode,
    addressCountry: 'IN'
  },
  geo: {
    '@type': 'GeoCoordinates',
    latitude: BUSINESS_INFO.geo.latitude,
    longitude: BUSINESS_INFO.geo.longitude
  },
  openingHoursSpecification: {
    '@type': 'OpeningHoursSpecification',
    dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    opens: '10:00',
    closes: '22:00'
  },
  sameAs: [
    BUSINESS_INFO.socialMedia.instagram,
    BUSINESS_INFO.socialMedia.facebook,
    BUSINESS_INFO.socialMedia.youtube,
    REVIEW_SOURCES.google.profileUrl,
    REVIEW_SOURCES.justdial.listingUrl
  ],
  priceRange: '₹₹',
  description: 'Petsmart Puppies is a pet shop in Sector 31, Noida offering puppies, pet food and pet accessories, with guidance for new and experienced pet parents.',
  areaServed: [
    { '@type': 'City', name: 'Noida' },
    { '@type': 'City', name: 'Greater Noida' },
    { '@type': 'City', name: 'Ghaziabad' },
    { '@type': 'AdministrativeArea', name: 'Delhi NCR' }
  ]
});
